import { Box, MenuItem, styled } from '@mui/material';
import { Icon } from '@sdb/planning-ui';

export const StyledEntityQuickDisconnect = styled(Box)(({ theme }) => ({
  minWidth: 300,
  maxWidth: 600,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[4],
  backgroundColor: theme.palette.background.paper
}));

export const StyledMenuItem = styled(MenuItem)({
  height: 40,
  justifyContent: 'space-between'
});

export const DisconnectIcon = styled(Icon)({
  width: 20,
  height: 20
});
